import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ADDONS_TYPES } from '../../../cart';
import { getMaxLengthForSize } from '../../cake-builder.helper';

@Component({
  standalone: false,
  selector: 'common-addons-section',
  templateUrl: './common-addons-section.component.html',
})
export class CommonAddonsSectionComponent {
  @Input() sortingAddons: any[] = [];
  @Input() cartLine: any;
  @Input() currency = 'kr';
  @Input() disabled = false;
  @Input() disabledChooseMotiveModal = false;
  @Input() isPiecesWithMultipleVariants = false;
  @Input() isRequirementsExist = false;
  @Input() isRequirementsFilled = true;
  @Input() requirementsFilling: { printingPictures?: { [key: number]: boolean } } = { printingPictures: {} };
  @Input() printingPictureMap: { [key: number]: any } = {};
  @Input() deposits: any[] = [];

  @Output() onPrintingPictureSelected = new EventEmitter<{ addOn: any, printingPicture: any }>();
  @Output() onExtraProductSelected = new EventEmitter<{ products: any[], groupId: number }>();
  @Output() onQuestionAnswerChange = new EventEmitter<{ answer: string, question: any }>();

  public ADDONS_TYPES = ADDONS_TYPES;

  public resolveMaxLength(addOn: any): number {
    if (addOn && addOn.hasDynamicLength && this.cartLine && this.cartLine.size) {
      return getMaxLengthForSize(this.cartLine.size.details.value);
    }

    return addOn.maxAnswerLength;
  }
}
